import { postWithAuth } from '@/lib/httpAdapter';
import apiUrl from './api';
import headerObject from '@/types/headerObj';

const endPoint = 'disconnectSlack/';
const url = apiUrl + endPoint;

export interface DisconnectSlackRequest {
  OrgUUID: string;
}

export interface DisconnectSlackResponse {
  Success: boolean;
  Error: string | null;
}

const disconnectSlack = async (
  req: DisconnectSlackRequest,
  headerObj: headerObject
): Promise<DisconnectSlackResponse | null> => {
  try {
    const res = await postWithAuth(
      url,
      {
        OrgUUID: req.OrgUUID,
      },
      {
        headers: {
          'Access-Control-Allow-Origin': '*',
          'Access-Control-Allow-Methods': 'POST,OPTIONS',
          ...headerObj,
        },
      }
    );

    if (!res.ok) {
      throw new Error(`HTTP error! status: ${res.status}`);
    }

    const text = await res.json();
    const data = JSON.parse(text);
    return data;
  } catch (err) {
    console.error('Error disconnecting Slack:', err);
    return null;
  }
};

export default disconnectSlack;
